class TestRoutesController {
  constructor($state) {
    this.$state = $state;
  }
  $onInit() {
    const excludedRouteNames = ['', 'test'];
    this.routes = this.$state
      .get()
      .filter(route => !excludedRouteNames.includes(route.name))
      .sort((a, b) => (a.name > b.name ? 1 : -1));
  }
}

TestRoutesController.$inject = ['$state'];

export default TestRoutesController;



// WEBPACK FOOTER //
// ./client/app/components/home/testRoutes/testRoutes.controller.js